<template>
    <div @click="switchClickEvent" :style="{ width: changeWidth }" style="display:flex; flex-direction: row-reverse; align-items: center;">
        <a class="switch" :class="{ active: isOn }"><span></span></a>
    </div>
</template>

<script>
export default {
    name: 'CommonSwitch',
    props: {
        switchClickEvent: {
            type: Function,
            default: () => { }
        },
        isOn: {
            type: Boolean,
            default: false
        },
        changeWidth: {
            type: String,
            default: '80px'
        }
    }
}
</script>

<style scoped>
.switch {
    display: inline-block;
    width: 46px;
    height: 27px;
    border-radius: 14px;
    background: #C7C7C7;
    position: relative;
    transition: background-color 0.3s;
    animation-timing-function: ease-out;
}

.switch span {
    width: 23px;
    height: 23px;
    border-radius: 50%;
    background: #ffffff;
    position: absolute;
    left: 2px;
    top: 2px;
    transition: left 0.3s;
    animation-timing-function: ease-out;
}

.switch.active {
    background: var(--color-main);
}

.switch.active span {
    left: 21px;
}
</style>